<template>
  <section class="blog-knot-together">
    <a :href="shopifyData.secLink ? shopifyData.secLink : '#'" :style="sectionStyles">
      <div class="blog_contianer">
        <div>
          <h2 class="blog_Heading" v-html="shopifyData.blogHeading" />
          <p class="blog_content blog_content_upper" v-html="shopifyData.blogText1" />
        </div>
        <div>
          <p class="blog_content" v-html="shopifyData.blogText2" />
        </div>
      </div>
    </a>
  </section>
</template>
<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    sectionStyles() {
      const backgroundImage = `url('${this.shopifyData.bgImage}')`;
      const deskPaddingTop = `${this.shopifyData.deskPaddingTop}px`;
      const mobPaddingTop = `${this.shopifyData.mobPaddingTop}px`;
      const deskPaddingBottom = `${this.shopifyData.deskPaddingBottom}px`;
      const mobPaddingBottom = `${this.shopifyData.mobPaddingBottom}px`;

      return {
        'background-image': backgroundImage,
        'padding-top': window.innerWidth > 768 ? deskPaddingTop : mobPaddingTop,
        'padding-bottom': window.innerWidth > 768 ? deskPaddingBottom : mobPaddingBottom,
      };
    },
  },
};
</script>

<style scoped>
.blog-knot-together a {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
}
.blog_contianer {
  max-width: 1060px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  align-items: center;
  justify-content: space-between;
}
.blog_content {
  color: #fff;
  text-align: center;
  font-family: adobe-caslon-pro, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%;
}
.blog_content_upper {
  max-width: 441px;
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 345px;
}
.blog_Heading {
  color: #fff;
  text-align: center;
  font-family: 'Big Caslon', serif;
  font-size: 72px;
  font-style: normal;
  font-weight: 500;
  line-height: 91%;
}

@media (max-width: 767px) {
  .blog_Heading {
    font-size: 36px;
  }
  .blog_content_upper {
    margin-bottom: 100px;
  }
  .blog_content {
    font-size: 20px;
  }
}

/* Responsive Breakpoints */
</style>
